<template>
  <div
    :id="scriptId"
    class="my-16 mx-auto"
    :class="{
      'container max-w-screen-xl' : !fluid,
      'max-w-screen-3xl': fluid
    }"
  >
    <div
      v-if="moduleTitle || moduleIntroTitle"
      class="mx-auto container max-w-screen-xl pl-0 break-all"
    >
      <h2 class="card-headline mt-8 mb-4 pl-0">
        <span
          v-if="moduleIntroTitle"
          class="-mt-8"
        >{{ moduleIntroTitle }}</span>
        {{ moduleTitle }}
      </h2>

    </div>
  </div>
</template>
<script>
import {selfDataRequestMixin} from "@/mixins";
  export default {
    name: 'ExternalScripts',
    mixins: [selfDataRequestMixin],
    props: {
      moduleInfo: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      scriptSrc() {
        return this.getPropValue('ScriptSrc')
      },
      moduleIntroTitle() {
        return this.getPropValue('ModuleIntroTitle')
      },
      moduleTitle() {
        return this.getPropValue('ModuleTitle')
      },
      scriptId() {
        return this.getPropValue('ScriptId')
      },
      fluid() {
        return this.getPropValue('Fluid') === 'True'
      },
    },
    mounted() {
      setTimeout(() => {
        let script = document.createElement("script");
        script.setAttribute("type", "text/javascript");
        script.setAttribute("src", this.scriptSrc);
        script.setAttribute("id", this.scriptId);
        document.getElementById(this.scriptId).appendChild(script);
      }, 10);
    }
  }
</script>
